import { ref, reactive } from '@vue/composition-api'
import formatDate from '@/utils/date-format'

export default function useFraudTrips(ctx) {
  const fraudTrips = ref([])
  const tableColumns = [
    {
      label: 'trip external id',
      key: 'trip_external_id',
    },
    {
      label: 'driver name',
      key: 'driver_name',
    },

    {
      label: 'driver phone',
      key: 'driver_phone',
    },
    {
      label: 'driver device type',
      key: 'driver_device_type',
    },
    {
      label: 'user name',
      key: 'user_name',
    },
    {
      label: 'user phone',
      key: 'user_phone',
    },
    {
      label: 'user device type',
      key: 'user_device_type',
    },
    {
      label: 'distance',
      key: 'distance',
    },
    {
      label: 'created at',
      key: 'created_at',
      formatter: val => formatDate(val),
    },

    {
      label: 'time',
      key: 'time',
    },
    {
      label: 'reason',
      key: 'reason',
    },
  ]
  const queryParams = reactive({
    user_phone: undefined,
    driver_phone: undefined,
    trip_id: undefined,
    trip_external_id: undefined,
  })
  const total = ref(0)
  const page = ref(1)
  const perPage = ref(10)
  const loading = ref(false)
  const fetchFraudTrips = async () => {
    try {
      loading.value = true
      fraudTrips.value = (await ctx.root.$store.dispatch('fraud/fetchFraudTrips', queryParams)).data?.data
      total.value = fraudTrips.value.length
    } catch (error) {
      console.log(error)
    } finally {
      loading.value = false
    }
  }
  const clearFilter = () => {
    queryParams.driver_phone = undefined
    queryParams.user_phone = undefined
    queryParams.trip_id = undefined
    queryParams.trip_external_id = undefined
    fetchFraudTrips()
  }
  const pushToTripDetails = event => {
    window.open(`${window.location.origin}/trips/${event.trip_id}`)
  }
  fetchFraudTrips()

  return {
    tableColumns,
    fraudTrips,
    total,
    page,
    perPage,
    loading,
    queryParams,
    fetchFraudTrips,
    clearFilter,
    pushToTripDetails,
  }
}
